export const getAddressDetailsFromGeocode = place => {
  const details = {
    address: place.formatted_address,
    latlng: [place.geometry.location.lat(), place.geometry.location.lng()].join(
      ',',
    ),
  }
  if (place.address_components) {
    place.address_components.forEach(component => {
      if (component.types.indexOf('country') !== -1) {
        details.country = component.short_name
      }
      if (component.types.indexOf('administrative_area_level_1') !== -1) {
        details.region = component.short_name
      }
      if (component.types.indexOf('locality') !== -1) {
        details.city = component.short_name
      }
      if (component.types.indexOf('postal_code') !== -1) {
        details.zip = component.short_name
      }
    })
  }
  return details
}
